module.exports = __webpack_public_path__ + "img/gongjue2@2x.4ed78884.png";